
class MegaMenu {

  /**
  * Constructor function
  *
  * Function that performs actions upon initiation of this class
  *
  * This function registers events for the navigation link used to trigger the mega menu,
  * as well as for the body which is used to detect when the user has clicked off the mega menu.
  * This function also sets the required CSS classes used for displaying the mega menus.
  *
  * @param    object  navMenu   Object containing the navMenu element
  * @return   void
  * @access   public
  */
  constructor(navMenu) {
    this.navMenu      = navMenu;
    this.megaMenuAll  = this.navMenu.querySelectorAll('.mega-menu');
    this.collapse     = this.navMenu.querySelector('.navbar__collapse');

    for (let i = 0; i < this.megaMenuAll.length; i++) {
      let body     = document.body;
      let menuItem = this.megaMenuAll[i];
      let megaLink = menuItem.closest('.nav__item').querySelector('.nav__link');

      body.addEventListener('click', (event) => {
        if (!this.navMenu.contains(event.target)) {
          document.body.classList.remove('active');
          this._closeMenu();
        }
      });

      megaLink.addEventListener('click', (event) => {
        const megaMenu = event.target.closest('.nav__item').querySelector('.mega-menu');

        if (!this.collapse.classList.contains('show')) {
          event.preventDefault();
        }

        if (megaMenu.classList.contains('active')) {
          document.body.classList.remove('active');
          this._closeMenu(megaMenu);
        } else {
          this.navMenu.classList.add('active');
          this._closeMenu();
          this._openMenu(megaMenu);
        }
      });
    }
  }

  /**
  * Open Menu function
  *
  * Function that opens the passed mega menu
  *
  * @param    object  megaMenu   Object containing the megaMenu element
  * @return   void
  * @access   private
  */
  _openMenu(megaMenu) {
    this.navMenu.classList.add('active');
    megaMenu.classList.add('active');
    document.body.classList.add('active');
  }

  /**
  * Close Menu function
  *
  * Function that closes the passed mega menu
  * Or closes all menus if a menu isn't passed to this function
  *
  * @param    object  megaMenu   Object containing the megaMenu element
  * @return   void
  * @access   private
  */
  _closeMenu(megaMenu) {
    if (megaMenu) {
      megaMenu.classList.remove('active');
      this.navMenu.classList.remove('active');
    } else {
      this.megaMenuAll.forEach((menu) => {
        menu.classList.remove('active');
        this.navMenu.classList.remove('active');
      });
    }
  }
}

export default MegaMenu;
